<script lang="ts">
  import type { ComponentProps } from "svelte";
  import { dataField } from "../../lib/dataform/dataFormLib.svelte";
  import Fieldset from "./Fieldset.svelte";
  import { partitionNames } from "./util";

  type PropsType = Omit<ComponentProps<typeof Fieldset>, 'children' | 'error'> & {
    name: string;
    required?: boolean;
    type?: string;
    placeholder?: string;
  }

  let {
    legend,
    name,
    required = false,
    disabled = undefined,
    type = "text",
    placeholder = undefined,
    class : className,
    postfix = null,
    ...rest
  } : PropsType = $props();

  let [inputClass, containerClass] = $derived.by(()=>partitionNames(className, /input-/))
  const field = dataField(name)
</script>
<Fieldset error={field.error as string} {legend} {disabled} class={containerClass} {postfix} {...rest}>
  <input
    {type}
    name={field.name}
    {placeholder}
    class="ui-input {inputClass}"
    class:border-error={field.error}
    bind:value={field.value}
    {required}
  />
</Fieldset>